import { render, staticRenderFns } from "./banner1-window.vue?vue&type=template&id=8bd75258&"
import script from "./banner1-window.vue?vue&type=script&lang=js&"
export * from "./banner1-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports